import styled from 'styled-components';
import Modal from '../../../../Modal';
import { px } from '../../../../../contrib/ui';

export const SendNotificationModalStyled = styled(Modal)`
  .modal-paper {
    max-width: ${px(600)};
    overflow: hidden;

    .modal-content {
      width: ${px(600)};
      overflow-x: hidden;
      overflow-y: hidden;

      .char-amount {
        margin-top: ${px(8)};
        text-align: right;
      }

      .form-helper-text {
        display: none;
      }
    }
  }
`;
